// extracted by mini-css-extract-plugin
export default {"item":"requisites_item__pEpzs","heading":"requisites_heading__nKozX","main":"requisites_main__4ZxBN"};